import Rule from "../../../../common/rule";

//In this case we only need to check the play for any penalties, that would prevent normal changing of downs

export default class AwardFirstDown extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            !ruleContext.PAT &&
            ruleContext.advanceDown &&
            !ruleContext.changeDownApplied &&
            ((gameContext.isHomePossession() &&
                gameContext.fieldPosition >= gameContext.firstDownAt) ||
                (gameContext.isVisitorPossession() &&
                    gameContext.fieldPosition <= gameContext.firstDownAt))
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.setAwardFirstDown(true);
    }
}
